import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoCookiesAction, 
  setIsFetching, 
  setFetchFailed, 
  setContent,
} from './actions';

export const fetchCookiesContent = () => {
  return async (dispatch: Dispatch<InfoCookiesAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoCookies;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('CookiesNotification');

      if (response.status === 200) {
        const newContent: Julius.Website.CookiesNotificationViewModel = await response.json();
        dispatch(setContent(newContent));
      } else {
        dispatch(setFetchFailed());
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/Redux/thunks.tsx